import React from 'react';

import Loading from '@components/Loading';
import { ContainedLoadingProps } from './localGeneric';
import { LoadingContainer, LoadingText } from './styles';

const ContainedLoading: React.FC<ContainedLoadingProps> = ({
  label,
  hasIcon,
  allHeight,
}) => {
  return (
    <LoadingContainer allHeight={allHeight}>
      <LoadingText>{label}</LoadingText>
      {hasIcon ? <Loading isContained /> : null}
    </LoadingContainer>
  );
};

export default ContainedLoading;
